import { StyleRulesCallback } from '@material-ui/core/styles/withStyles';

const stageSelectStyle: StyleRulesCallback = () => ({
  root: {
    justifyContent: 'left',
  },
});

export default stageSelectStyle;
